module.exports = __webpack_public_path__ + "static/website-app-service-screenshot-113f17f23d851b5fb102be3398d5a63a.png";